<div style="padding-top:0px;" class="col-12 md:col-12 grid">
    <div *ngIf="shipment.bookingType">
        <h4 class="text-center" style="color:var(--primary-color); padding-bottom:4px;">
            {{ 'RECEIVER' | translate }}
        </h4>

        <form [formGroup]="addressForm">
            <div class="p-fluid p-formgrid grid row-gap-2">

                <!-- Customer / Name -->
                <div class="col-12 md:col-12">
                    <span class="p-float-label">
                        <p-autoComplete formControlName="name" [suggestions]="foundCustomers" [minLength]="3" [delay]="500" inputId="name" autocomplete="anyrandomstring"
                                        [showEmptyMessage]="true" emptyMessage="{{ 'NORESULTS' | translate }}" [showClear]="true" [field]="formattedCustomerName" (completeMethod)="searchCustomer($event)" (onSelect)="setCustomer($event.value)">

                            <ng-template let-customer pTemplate="item">
                                <div class="customer-item">
                                    <div> {{ customer.name }}
                                        <span *ngIf="customer.address" class="grayedText">
                                            {{ customer.address.street }},
                                            {{ customer.address.zipCode }},
                                            {{ customer.address.city }}
                                        </span>

                                        <span *ngIf="customer.contactPerson" style="font-size:12px; color:gray;">
                                            | {{ 'CUSTOMER.FORM.CONTACTPERSON' | translate }}
                                            {{ customer.contactPerson.name }}
                                            <span *ngIf="customer.contactPerson.email"> , {{ customer.contactPerson.email }} </span>

                                            <span *ngIf="customer.contactPerson.phone">
                                                , {{ customer.contactPerson.phone }}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </p-autoComplete>

                        <label for="name">
                            {{ 'NAME' | translate }} {{ 'SEARCHFIELD' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Address / Street -->
                <div class="col-12 md:col-4">
                    <span class="p-float-label">
                        <p-autoComplete
                                        formControlName="street"
                                        [suggestions]="foundAddresses"
                                        [minLength]="3"
                                        [delay]="500"
                                        inputId="addressStreet"
                                        autocomplete="anyrandomstring"
                                        [showEmptyMessage]="true"
                                        emptyMessage="{{ 'NORESULTS' | translate }}"
                                        [showClear]="true"
                                        [field]="formattedStreetName"
                                        (completeMethod)="searchAddress($event)"
                                        (onClear)="onClearAddress()"
                                        (onSelect)="setAddress($event.value)">

                            <ng-template let-address pTemplate="item">
                                <div class="address-item">
                                    <div>
                                        <img
                                             src="assets/demo/flags/flag_placeholder.png"
                                             [class]="'flag flag-' + address.countryCode?.toLowerCase()" />

                                        {{ address.street }},

                                        <span class="grayedText">
                                            {{ address.zipCode }} {{ address.city }}
                                        </span>

                                        <span *ngIf="isDev()">
                                            , {{ 'CUSTOMER.FORM.VALIDATEDBY' | translate }} :
                                            {{ address.validatedBy }}
                                        </span>
                                    </div>
                                </div>
                            </ng-template>
                        </p-autoComplete>

                        <label for="addressStreet">
                            <span *ngIf="shipment.bookingType === 'PARCELSHOP'">
                                {{ 'PARCELSHOPNAME' | translate }}
                            </span>
                            {{ 'ADDRESS' | translate }} {{ 'SEARCHFIELD' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Zip Code -->
                <div class="col-12 md:col-2">
                    <span class="p-float-label">
                        <input
                               formControlName="zipCode"
                               pInputText
                               id="zipCode"
                               autocomplete="anyrandomstring"
                               [tabindex]="validatedAddress === true ? -1 : 0"
                               type="text" />

                        <label for="zipCode">
                            {{ 'ZIPCODE' | translate }}
                        </label>
                    </span>
                </div>

                <!-- City -->
                <div class="col-12 md:col-3">
                    <span class="p-float-label">
                        <input
                               formControlName="city"
                               pInputText
                               id="city"
                               autocomplete="anyrandomstring"
                               [tabindex]="validatedAddress === true ? -1 : 0"
                               type="text" />

                        <label for="city">
                            {{ 'CITY' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Country -->
                <div class="col-12 md:col-3">
                    <span class="p-float-label">
                        <p-dropdown
                                    formControlName="countryCode"
                                    inputId="countryCode"
                                    [options]="countries"
                                    optionValue="code"
                                    optionLabel="name"
                                    placeholder="Land">

                            <ng-template pTemplate="selectedItem" let-country>
                                <div class="country-item country-item-value" *ngIf="country">
                                    <img
                                         src="assets/demo/flags/flag_placeholder.png"
                                         [class]="'flag flag-' + country.code.toLowerCase()" />

                                    {{ 'COUNTRIES.' + country.code | translate }}
                                </div>
                            </ng-template>

                            <ng-template let-country pTemplate="item">
                                <div class="country-item">
                                    <img
                                         src="assets/demo/flags/flag_placeholder.png"
                                         [class]="'flag flag-' + country.code.toLowerCase()" />

                                    {{ 'COUNTRIES.' + country.code | translate }}
                                </div>
                            </ng-template>
                        </p-dropdown>

                        <label for="countryCode">
                            {{ 'COUNTRY' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Parcel Shops -->
                <div class="col-12 md:col-12" *ngIf="shipment.bookingType === 'PARCELSHOP'">
                    <span class="p-float-label">
                        <p-dropdown
                                    formControlName="parcelShopId"
                                    inputId="parcelShops"
                                    [options]="foundParcelShops"
                                    optionValue="number"
                                    [optionLabel]="formattedParcelShopName"
                                    [loading]="loadingParcelShops"
                                    placeholder="{{ 'PARCELSHOPNAME' | translate }}"
                                    emptyMessage="{{ 'PARCELSHOPSEMPTYMESSAGE' | translate }}"
                                    [dropdownIcon]="loadingParcelShops ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'">

                            <ng-template let-parcelShop pTemplate="item">
                                <div class="flex align-items-center gap-2">
                                    <div *ngIf="parcelShop.number" style="color:gray;">
                                        {{ parcelShop.number }}:
                                    </div>

                                    <div>
                                        {{ parcelShop.companyName }},
                                        {{ parcelShop.streetname }},
                                        {{ parcelShop.cityName }},
                                        {{ parcelShop.zipCode }}
                                        {{ parcelShop.countryCodeISO3166A2 }}
                                    </div>
                                </div>
                            </ng-template>
                        </p-dropdown>

                        <label for="parcelShops">
                            {{ 'PARCELSHOPNAME' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Contact Person -->
                <div class="col-12 md:col-4">
                    <span class="p-float-label">
                        <p-autoComplete
                                        formControlName="contactPerson"
                                        inputId="contactPerson"
                                        [dropdown]="!!contactPersons?.length"
                                        [suggestions]="filteredContactPersons"
                                        field="name"
                                        [showEmptyMessage]="true"
                                        emptyMessage="{{ 'NOCONTACTPERSONONCUSTOMER' | translate }}"
                                        (completeMethod)="filterContactPersons($event)"
                                        (onSelect)="onContactPersonSelect($event.value)">
                        </p-autoComplete>

                        <label for="contactPerson" *ngIf="shipment.bookingType !== 'PARCELSHOP'">
                            {{ 'CONTACTPERSON' | translate }}
                        </label>

                        <label for="contactPerson" *ngIf="shipment.bookingType === 'PARCELSHOP'">
                            {{ 'FULLNAME' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Contact Phone -->
                <div class="col-12 md:col-4">
                    <span class="p-float-label">
                        <input
                               formControlName="contactPhone"
                               pInputText
                               id="contactPhone"
                               type="text" />

                        <label for="contactPhone">
                            <span *ngIf="shipment.bookingType === 'PARCELSHOP'">
                                {{ 'RECEIVER' | translate }}
                            </span>
                            {{ 'MOBILE' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Contact Email -->
                <div class="col-12 md:col-4">
                    <span class="p-float-label">
                        <input
                               formControlName="contactEmail"
                               pInputText
                               id="contactEmail"
                               type="text" />

                        <label for="contactEmail">
                            <span *ngIf="shipment.bookingType === 'PARCELSHOP'">
                                {{ 'RECEIVER' | translate }}
                            </span>
                            {{ 'EMAIL' | translate }}
                        </label>
                    </span>
                </div>

                <!-- Note -->
                <div class="col-12 md:col-12">
                    <span class="p-float-label">
                        <input
                               formControlName="note"
                               pInputText
                               id="note"
                               type="text" />

                        <label for="note">
                            {{ 'NOTE' | translate }}
                        </label>
                    </span>

                    <div *ngIf="shipment.bookingType === 'GLS'">
                        <small
                               class="p-invalid"
                               style="margin-left:6px;"
                               [ngStyle]="{
                color: (addressForm.get('note')?.value?.length || 0) > 40 ? '#FC6161' : 'green'
              }">
                            {{ addressForm.get('note')?.value?.length || 0 }} / 40
                        </small>
                    </div>
                </div>

                <!-- Save Address -->
                <div class="field-checkbox col-2 md:col-2 saveCheckbox">
                    <p-checkbox
                                formControlName="saveAddress"
                                inputId="saveAddress"
                                [binary]="true">
                    </p-checkbox>

                    <label for="saveAddress">
                        {{ 'SAVEADDRESS' | translate }}
                    </label>
                </div>

                <!-- Services - Single Select -->
                <div
                     class="col-12 md:col-12 grid servicesList"
                     style="padding-top:0px; padding-bottom:0px; margin-top:2px;"
                     *ngIf="shipment.bookingType && services && services.length > 0 && !multiSelectServices">

                    <div class="col-12 md:col-4" style="padding-bottom:0px;">
                        <h4 style="color:var(--primary-color); line-height:0px; margin-top:8px;">
                            {{ 'SERVICES' | translate }}
                        </h4>
                    </div>

                    <div class="col-4 md:col-4">
                        <p-radioButton
                                       (onClick)="externalServiceChange('null')"
                                       formControlName="externalCarrierServices"
                                       name="externalCarrierServices"
                                       [value]="null"
                                       label="{{ 'NOEXTRASERVICES' | translate }}">
                        </p-radioButton>
                    </div>

                    <div *ngFor="let service of services" class="col-4 md:col-4">
                        <p-radioButton formControlName="externalCarrierServices" name="externalCarrierServices" [value]="service" (onClick)="externalServiceChange(service)" [label]="service.code.toUpperCase() | translate"> </p-radioButton>
                    </div>
                </div>

                <!-- Services - Multi Select -->
                <div
                     class="col-12 md:col-12 grid servicesList"
                     style="padding-top:0px; padding-bottom:0px; margin-top:2px;"
                     *ngIf="shipment.bookingType && services && services.length > 0 && multiSelectServices">

                    <div class="col-12 md:col-4" style="padding-bottom:0px;">
                        <h4 style="color:var(--primary-color); line-height:0px; margin-top:8px;">
                            {{ 'SERVICES' | translate }}
                        </h4>
                    </div>

                    <div class="col-4 md:col-4">
                        <p-button
                                  type="button"
                                  label="{{ 'NOEXTRASERVICES' | translate }}"
                                  (onClick)="removeAllServices($event)">
                        </p-button>
                    </div>

                    <div *ngFor="let service of services" class="col-4 md:col-4">
                        <p-checkbox
                                    formControlName="externalCarrierServices"
                                    [value]="service"
                                    (onChange)="externalServiceChange($event)"
                                    [label]="service.code.toUpperCase() | translate">
                        </p-checkbox>
                    </div>
                </div>

            </div>
        </form>
    </div>
</div>